import React from "react";
import { useParams } from 'react-router-dom'; // 引入useParams
import s from './index.module.css';
import data from '../../../dada.json'; // 引入数据


export default function Detail() {
  const { number } = useParams(); // 获取URL中的number参数
  const { projects } = data;

  // 根据number筛选出对应的项目
  const project = projects.find(p => p.number === number);

  if (!project) {
    return <div>项目未找到</div>; // 如果没有找到对应项目，显示“项目未找到”
  }

  return (
    <div className={s.detail}>
      <div className={s.info}>
        <div className={s.detail_left}>
          <img src={`/assets/images/example/${project.image}`} alt="项目图片" />
        </div>
        <div className={s.detail_right}>
          <div className={s.detail_right_title}>
            {project.name}
          </div>
          <div className={s.detail_right_info}>
            <div className={s.info_left}>
              <div className={s.info_left_no}>
                产品编号：{project.number}
              </div>
              <div className={s.info_left_type}>
                项目类型：{project.project}
              </div>
              <div className={s.info_left_patentType}>
                专利类型：{project.patentType}
              </div>
              <div className={s.info_left_address}>
                所在地区：{project.area}
              </div>
              <div className={s.info_left_number}>
                专利号码：{project.patentNumber}
              </div>
              <div className={s.info_left_belong}>
                项目归属：{project.projectOwnership}
              </div>
              <div className={s.info_left_maturity}>
                项目成熟度：{project.maturity}
              </div>
              <div className={s.info_left_transfer}>
                <div className={s.info_left_transfer_title}>
                  转让方式：
                </div>
                <div className={s.info_left_transfer_content}>
                  {project.transferMethod}
                </div>
              </div>
              <div className={s.info_left_price}>
                转让价格：
                <span className={s.info_left_price_value}>
                  {project.price}
                </span>
              </div>
            </div>
            <div className={s.info_right}>
              <div>&nbsp;&nbsp;</div>
              <div className={s.info_right_classify}>
                项目分类：{project.projectClassification}
              </div>
              <div className={s.info_right_publish}>
                项目发布：{project.projectRelease}
              </div>
              <div className={s.info_right_time}>
                发布时间：{project.releaseTime}
              </div>
              <div className={s.info_right_status}>
                销售状况：{project.sales}
              </div>
              <div className={s.info_right_service}>
                增值服务：{project.valueAddedServices}
              </div>
              <div className={s.info_right_other}>
                其他说明：
                <div className={s.info_right_other_content}>
                  {project.others}
                </div>
              </div>
            </div>
          </div>
          <div className={s.detail_right_service}>
            <a href="/" className={s.service_consult}>
              立即咨询
            </a>
            <a href="/" className={s.service_buy}>
              下单购买
            </a>
          </div>
        </div>
      </div>
      <div className={s.information}>
        <div className={s.information_title}>
          项目信息
        </div>
        <div className={s.information_content}>
          {project.projectInformation}
        </div>
      </div>
    </div>
  );
}
